<template>
  <export-data-reupload
    :is-loading="isLoading"
    :display-success="displaySuccess"
    @toggle-snackbar="displaySuccess = $event"
    @reupload="onReupload"
  />
</template>

<script>
import { API } from '@/utils/api'
import ExportDataReupload from '../components/ExportDataReupload.vue'
export default {
  components: {
    ExportDataReupload,
  },
  data() {
    return {
      isLoading: false,
      displaySuccess: false,
    }
  },

  methods: {
    onReupload(args) {
      this.isLoading = true
      return API.call('/$v/tools/export_data_reupload.json', {
        reupload_configs: args
      })
        .then(() => {
          this.displaySuccess = true
        })
        .finally(() => this.isLoading = false)
    }
  }
}
</script>
